import { cn } from "@/lib/utils";

// Large numeric telemetry readout used across vehicle/cockpit screens.
export function Telemetry({ value, unit, label, accent, className, testId }) {
  return (
    <div className={cn("min-w-0", className)} data-testid={testId}>
      <div className="flex items-baseline gap-1">
        <span className={cn("font-display text-3xl font-semibold tabular-nums tracking-tight sm:text-[2rem]", accent && "text-primary")}>
          {value}
        </span>
        {unit && <span className="text-sm text-muted-foreground">{unit}</span>}
      </div>
      <div className="mt-1 text-xs uppercase tracking-wider text-muted-foreground">{label}</div>
    </div>
  );
}

export function StatItem({ label, value, sub, className }) {
  return (
    <div className={cn("rounded-xl border border-border/60 bg-card/50 p-4", className)}>
      <div className="text-xs uppercase tracking-wider text-muted-foreground">{label}</div>
      <div className="mt-1.5 font-display text-xl font-semibold tabular-nums">{value}</div>
      {sub && <div className="mt-0.5 text-xs text-muted-foreground">{sub}</div>}
    </div>
  );
}
